<section>
  <div class="row app-auth-page">
    <div class="col-form col-md-12 d-flex justify-content-center align-items-center">
      <div class="app-auth-container">
        <router-outlet></router-outlet>
      </div>
    </div>
    <!--div class="col-md-7 d-none d-md-block app-carousel-container">
      <ngb-carousel [showNavigationArrows]="false">
        <ng-template ngbSlide>
          <div class="carousel-bg img-1"></div>
        </ng-template>
        <ng-template ngbSlide>
          <div class="carousel-bg img-2"></div>
        </ng-template>
        <ng-template ngbSlide>
          <div class="carousel-bg img-3"></div>
        </ng-template>
      </ngb-carousel>
    </div-->
  </div>
</section>
